import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { OrderInvoiceBlockConfig } from '@front-platform/content-builder';
import { orderInvoiceBlockResolveConfig } from '@front-platform/content-builder';
import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { DoodOrderPaymentModel } from '@store/order/order.model';

import {
  ORDER_INVOICE_BLOCK_DATA_SOURCE,
  ORDER_INVOICE_BLOCK_EMPTY_VM,
} from './order-invoice-block-view-model';
import { provideOrderInvoiceBlockDataSource } from './order-invoice-block-data-source.providers';

export interface OrderInvoiceBlockRuntimeConfig {}

export type OrderInvoiceBlockConfigInput = Partial<
  Omit<OrderInvoiceBlockConfig, keyof OrderInvoiceBlockRuntimeConfig> &
    OrderInvoiceBlockRuntimeConfig
>;
export type OrderInvoiceBlockResolvedConfig = Omit<
  OrderInvoiceBlockConfig,
  keyof OrderInvoiceBlockRuntimeConfig
> &
  Partial<OrderInvoiceBlockRuntimeConfig>;
export interface OrderInvoiceBlockContract extends ConfigComponentContract<
  OrderInvoiceBlockConfigInput,
  OrderInvoiceBlockResolvedConfig
> {}

@Component({
  selector: 'app-order-invoice-block',
  templateUrl: './order-invoice-block.component.html',
  standalone: false,
  providers: [...provideOrderInvoiceBlockDataSource()],
})
export class OrderInvoiceBlockComponent implements OrderInvoiceBlockContract {
  readonly config = input<OrderInvoiceBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    OrderInvoiceBlockConfig,
    OrderInvoiceBlockRuntimeConfig
  >(orderInvoiceBlockResolveConfig, () => ({ config: this.config() }));

  private readonly blockDataSource = inject(ORDER_INVOICE_BLOCK_DATA_SOURCE);
  private readonly invoiceVm = toSignal(this.blockDataSource.vm$, {
    initialValue: ORDER_INVOICE_BLOCK_EMPTY_VM,
  });

  readonly title = computed(() => this.resolvedConfig()['title'] as unknown as string);
  readonly downloadLabel = computed(
    () => this.resolvedConfig()['download_label'] as unknown as string,
  );

  protected readonly invoicePayments = computed(() => this.invoiceVm().payments);

  protected buildButtonLabel(payment: DoodOrderPaymentModel): string {
    return payment.invoice_number
      ? `${this.downloadLabel()} ${payment.invoice_number}`
      : this.downloadLabel();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(OrderInvoiceBlockComponent, { 'keyAliases': {} });
